import { render, staticRenderFns } from "./crear_producto_dialog.vue?vue&type=template&id=31a4aa73&lang=pug&"
import script from "./crear_producto_dialog.vue?vue&type=script&lang=js&"
export * from "./crear_producto_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports